import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../requestMethods';

/**
 * Redirects /api/mosques/contributor-response to the actual API server.
 * Used when email links point to the main site (chorullapalli.com) instead of the API (api.chorullapalli.com).
 */
const ContributorResponseRedirect = () => {
  const location = useLocation();
  const apiBase = BASE_URL.replace(/\/$/, '');
  const apiUrl = `${apiBase}/mosques/contributor-response${location.search || ''}`;

  useEffect(() => {
    window.location.href = apiUrl;
  }, [apiUrl]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <p>Redirecting...</p>
    </div>
  );
};

export default ContributorResponseRedirect;
